// import Veggi from "../components/Veggi";
// import Popular from "../components/Popular";
import React, { lazy, Suspense } from "react";
import { motion } from "framer-motion";
const Veggi = lazy(() => import("../components/Veggi"));
const Popular = lazy(() => import("../components/Popular"));

export default function Home() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <motion.div
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Veggi />
        <Popular />
      </motion.div>
    </Suspense>
  );
}
